<script>
import NavBar from "@/components/NavBar";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    
    FooterBar
  }
}
</script>

<style >
/*html.has-navbar-fixed-top {padding-top:10px !important}*/
</style>

<template>
  <div>
    <nav-bar  />

    <section class="main-content  is-fullheight">
		
      <div class=" section pt-1">
        <div class="container">
          <router-view/>
        
        
        </div>
      </div>
		</section>

    <footer-bar />

  </div>

</template>